import { Wrapper as WrapperComponent } from 'components/BaseLayout/components/Wrapper';
import styled, { css, rem, tablet } from 'theme';

export const PageHeader = styled.div<{ hasTabs: boolean }>`
  display: flex;
  flex-direction: column;

  color: var(--sys-color-on-primary);
  background: linear-gradient(
    90deg,
    var(--sys-color-primary-high) 0.02%,
    var(--sys-color-primary) 69.99%,
    var(--ref-color-kumquat-40) 99.98%
  );

  padding-bottom: ${(p) => (p.hasTabs ? rem(10) : 0)};
`;

export const PageTitle = styled.div`
  color: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${rem(60)};

  ${tablet(css`
    min-height: ${rem(104)};
  `)}
`;

export const Title = styled.h1`
  color: inherit;
  font-weight: var(--ref-font-weight-600);
  line-height: normal;
  margin: 0;
`;

export const BreadCrumbs = styled.div`
  font-size: ${rem(16)};
  font-family: var(--ref-font-family-opensans);
  display: none;

  ${tablet(css`
    display: block;
  `)}

  a,
  a:hover {
    color: inherit;
  }
`;

export const Wrapper = styled(WrapperComponent)`
  margin: 0;
  align-self: center;
`;
